import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { FirebaseUtilitiesService } from '../../services/firebase-utilities.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-two-factor-sign-in-modal',
  templateUrl: './two-factor-sign-in-modal.component.html',
  styleUrls: ['./two-factor-sign-in-modal.component.scss'],
  standalone: false
})
export class TwoFactorSignInModalComponent implements OnInit, OnDestroy {
  code = '';
  error = '';
  verifying = false;
  counter = 0;
  private timer: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TwoFactorSignInModalComponent>,
    private firebase_$: FirebaseUtilitiesService,
    private auth_$: AuthService,
    private utils_$: UtilsService,
  ) {}

  ngOnInit(): void {}

  async validateCode(): Promise<void> {
    if (this.code.length < 6 || this.verifying) return;
    this.verifying = true;
    this.error = '';
    try {
      const result = await this.firebase_$.validate2FACode(this.data.email, this.code, this.data.method);
      if (result === true) {
        this.dialogRef.close('success');
      } else {
        this.error = 'Incorrect code. Please try again.';
        this.code = '';
      }
    } catch {
      this.error = 'Verification failed. Please try again.';
      this.code = '';
    } finally {
      this.verifying = false;
    }
  }

  handleResend(): void {
    const code = this.utils_$.generateValidationCode();
    this.auth_$.sendVerificationCode(code, this.data.email);
    this.counter = 20;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      if (this.counter > 0) { this.counter--; }
      else { clearInterval(this.timer); }
    }, 1000);
  }

  handleCancel(): void {
    this.dialogRef.close('cancel');
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
}
